"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNameParts = formatNameParts;
exports.getStringCase = getStringCase;
exports.orderNameParts = orderNameParts;
exports.orderNamePieces = orderNamePieces;

function getStringCase(string) {
  var a = string.toUpperCase();
  var b = string.toLowerCase();

  for (var i = 0; i < string.length; i++) {
    if (a[i] !== b[i]) {
      return a[i] === string[i];
    }
  }

  return null;
}

function formatNameParts(parts) {
  if (parts.length === 0) {
    return undefined;
  }

  var piece = '';

  while (parts.length > 1) {
    var _parts$shift = parts.shift(),
        value = _parts$shift.value,
        hyphenated = _parts$shift.hyphenated;

    piece += value + (hyphenated ? '-' : ' ');
  }

  var output = piece + parts[0].value;
  return output[0] && output;
}

function orderNameParts(parts) {
  var orderGiven = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var given = [];
  var undecided = [];

  if (orderGiven) {
    while (parts.length > 1 && parts[0].upperCase !== false) {
      given.push.apply(given, undecided);
      undecided.length = 0;

      while (parts.length > 1 && parts[0].upperCase !== false && !parts[0].hyphenated) {
        given.push(parts.shift());
      }

      while (parts.length > 0 && parts[0].upperCase !== false && parts[0].hyphenated) {
        undecided.push(parts.shift());
      }
    }
  }

  var prefix = [];
  var family = [];

  while (parts.length > 1) {
    prefix.push.apply(prefix, family);
    family.length = 0;

    while (parts.length > 1 && parts[0].upperCase === false) {
      prefix.push(parts.shift());
    }

    while (parts.length > 0 && parts[0].upperCase !== false) {
      family.push(parts.shift());
    }
  }

  if (undecided.length) {
    family.unshift.apply(family, undecided);
  }

  if (parts.length) {
    family.push(parts[0]);
  }

  return [formatNameParts(given), formatNameParts(prefix), formatNameParts(family)];
}

function orderNamePieces(pieces) {
  if (pieces[0][0].label) {
    var _name = {};

    var _iterator = _createForOfIteratorHelper(pieces),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 1),
            _step$value$ = _step$value[0],
            value = _step$value$.value,
            label = _step$value$.label;

        _name[label] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _name;
  }

  var name = {};

  var _orderNameParts = orderNameParts(pieces[0], pieces.length === 1),
      _orderNameParts2 = _slicedToArray(_orderNameParts, 3),
      given = _orderNameParts2[0],
      prefix = _orderNameParts2[1],
      family = _orderNameParts2[2];

  if (family) {
    name.family = family;
  }

  if (prefix) {
    name.prefix = prefix;
  }

  if (pieces.length === 3) {
    name.given = formatNameParts(pieces[2]);
    name.suffix = formatNameParts(pieces[1]);
  } else if (pieces.length === 2) {
    name.given = formatNameParts(pieces[1]);
  } else if (given) {
    name.given = given;
  }

  return name;
}